export default function Script({
  children,
  index,
  className = '',
  isScripts,
  currentScript,
  handleClickScript,
}: {
  children: React.ReactNode
  index: number
  className?: string
  isScripts: boolean
  currentScript: number
  handleClickScript: (_scriptNumber: number) => void
}) {
  return (
    <button
      style={{
        cursor: 'pointer',
        padding: '.5rem',
      }}
      className={`js-script ${isScripts && currentScript === index ? 'active' : ''} ${className}`}
      onClick={() => handleClickScript(index)}
      tabIndex={-1}
    >
      {children}
    </button>
  )
}
